export const NEWS_CATEGORY_SEARCH = 'NEWS_CATEGORY_SEARCH'
export const NEWS_CATEGORY_DETAIL = 'NEWS_CATEGORY_DETAIL'
export const NEWS_CATEGORY_GETALL = 'NEWS_CATEGORY_GETTALL'
export const NEWS_CATEGORY_TREE = 'NEWS_CATEGORY_TREE'
